import { ScopeOfPracticeEnum } from '@umss/shared/utils';

export interface CorporateDefaultBillableRateDto {
  /**
   * format: uuid
   */
  corporationId?: string;

  corporationName?: string;

  scopeOfPractice?: ScopeOfPracticeEnum;

  scopeOfPracticeDisplay?: string;

  /**
   * format: double
   */
  hourlyRate?: number;

  /**
   * format: double
   */
  urgentHourlyRate?: number;

  isActive?: boolean;

  scheduledRates?: CorporateScheduledBillableRateDto[];

  /**
   * format: uuid
   */
  id?: string;

  /**
   * format: date-time
   */
  createdAt?: string;

  /**
   * format: date-time
   */
  updatedAt?: string;
}

export interface CorporateScheduledBillableRateDto {
  /**
   * format: uuid
   */
  corporateDefaultBillableRateId?: string;

  /**
   * format: double
   */
  rate?: number;

  /**
   * format: date-time
   */
  effectiveFrom?: string;

  /**
   * format: date-time
   */
  effectiveTo?: string;

  /**
   * format: uuid
   */
  id?: string;

  /**
   * format: date-time
   */
  createdAt?: string;

  /**
   * format: date-time
   */
  updatedAt?: string;
}
